<template>
  <div class="id-photo">
    <div class="upload-box">
      <p>{{$t('APP-FIELD-0067')}}</p>
      <el-upload
              class="uploader"
              action=""
              :show-file-list="false"
              :http-request="uploadFrontImg"
              :before-upload="beforeImgUpload"

      >
        <img :src="firstImg">
      </el-upload>

    </div>

    <div class="upload-box">
      <p>{{$t('APP-FIELD-0068')}}</p>
      <el-upload
              class="uploader"
              action=""
              :show-file-list="false"
              :http-request="uploadBackImg"
              :before-upload="beforeImgUpload"

      >
        <img :src="secondImg">
      </el-upload>

    </div>

  </div>
</template>

<script>
  import API from "@/api"

  export default {
    name: "IDPhoto",
    props: {
      item: {
        type: Object
      },
      firstImg:{
        type: String,
        default: ""
      },

      secondImg:{
        type: String,
        default: ""
      }
    },

    methods: {
      uploadFrontImg(res) {
        API.uploadPic(res.file)
          .then((res) =>{
            // 改 2021-05-08
            if(res.result === true){
              this.item.frontId = res.message.filePath
            }
            // this.$emit("upload-front", res)
          })
      },

      uploadBackImg(res) {
        API.uploadPic(res.file)
          .then((res) =>{
            if(res.result === true) {
              this.item.backId = res.message.filePath
            }

            // this.$emit("upload-back", res)
          })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .id-photo {
    margin: 0 0 84px 0 ;
    .upload-box {
      display: inline-block;
      margin-right: 50px;
      p{
        font-family: Nunito-Regular;
        font-size: 16px;
        color: #2C405A;
        letter-spacing: 0.08px;
        line-height: 24px;
        margin-bottom: 20px;
      }
    }
    .uploader {

      img {
        width: 256px;
        height: 156px;
        border: 1px solid #E5F5FE;
        border-radius: 8px;
      }

    }

  }
</style>